module.exports = __webpack_public_path__ + "static/lean_process-90578d17fc2e9d9de38654f13778ad80.png";